module.exports = __webpack_public_path__ + "img/006330.2987109a.svg";